import type { JSX } from 'react';
import React from 'react';
import { Redirect, Switch, useLocation, useParams } from 'react-router-dom';

import { useFlags } from '@feathr/report_components';

import FundraisePage from '../FundraisePage';
import DonationFormEditor from '../FundraisePage/DonationFormEditPage/DonationFormEditPage';
import GrowthCreditsPage from '../FundraisePage/GrowthCreditsPage';
import StripeOnboardingRedirect from '../FundraisePage/StripeOnboardingRedirect';
import RouteWithPermissions from './RouteWithPermissions';

/**
 * Redirect from /fundraise/settings to /fundraise while preserving query params.
 * This enables deep linking to the settings tab with query params like ?modal=crm&step=3
 */
function FundraiseSettingsRedirect(): JSX.Element {
  const { accountId } = useParams<{ accountId: string }>();
  const location = useLocation();
  // Preserve existing query params and add tab=settings
  const params = new URLSearchParams(location.search);
  params.set('tab', 'settings');
  return <Redirect to={`/${accountId}/fundraise?${params.toString()}`} />;
}

function FundraiseRoutes(): JSX.Element {
  const { showFundraise } = useFlags();

  return (
    <Switch>
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/stripe/onboarding-url'}
      >
        <StripeOnboardingRedirect />
      </RouteWithPermissions>
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/settings'}
      >
        <FundraiseSettingsRedirect />
      </RouteWithPermissions>
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/growth-credits'}
      >
        <GrowthCreditsPage />
      </RouteWithPermissions>
      <RouteWithPermissions condition={showFundraise} exact={true} path={'/:accountId/fundraise'}>
        <FundraisePage />
      </RouteWithPermissions>
      {/* TODO: Add DonationFormReportPage when it is ready. */}
      {/* <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/:donationFormId'}
      >
        <DonationFormReportPage />
      </RouteWithPermissions> */}
      <Redirect
        exact={true}
        from={'/:accountId/fundraise/:donationFormId'}
        to={'/:accountId/fundraise/:donationFormId/edit'}
      />
      <RouteWithPermissions
        condition={showFundraise}
        exact={true}
        path={'/:accountId/fundraise/:donationFormId/edit'}
      >
        <DonationFormEditor />
      </RouteWithPermissions>
    </Switch>
  );
}

export default FundraiseRoutes;
